export default __webpack_public_path__ + "static/PyTamaro-horizontal-33e91b681d266701dd297fa961491adf.png";